export function headerFunc() {
  let resizecheck;
  // ハンバーガーメニュー実装
  $('.navToggle').on('click', function () {
    $('.navToggle').toggleClass('closeNav');
    $('.headerNav').toggleClass('openNav');
  });

  $('#closeJs').on('click', function () {
    $('.navToggle').removeClass('closeNav');
    $('.headerNav').removeClass('openNav');
  });

  $('#jsnav').hover(
    function () {
      resizecheck = $('#responsibleCheck').width();
      if (resizecheck == '1') {
        $('.accordion').addClass('open');
      }
    },
    function () {
      if (resizecheck == '1') {
        $('.accordion').removeClass('open');
      }
    }
  );
  $('#jsnav').on('click', function () {
    resizecheck = $('#responsibleCheck').width();
    if (resizecheck == '2') {
      $(this).toggleClass('open')
      $('.accordion').stop().slideToggle();
    }
  });
}

export function headerScrFunc() {
  console.log('スクロールで呼ばれます。');
}